import { EMPTY_FIELD } from 'constants/emptyField';

import React, { ReactNode } from 'react';

import get from 'lodash/get';
import { FunctionField } from 'react-admin';
import { Stack } from 'shared/mui/Stack/Stack';
import { FunctionFieldProps } from 'shared/react-admin/Fields';

export interface EmbeddedItem {
  id: string | number;
  '@id': string;
  name?: string;
}

export interface EmbeddedArrayFieldProps<
  RecordType extends object = any,
  ItemType extends EmbeddedItem = EmbeddedItem,
> extends Omit<FunctionFieldProps, 'render'> {
  sourceField: string;
  emptyText?: string;
  render?: (values: ItemType[], record: RecordType) => ReactNode;
}

export const EmbeddedArrayField = <
  RecordType extends object = any,
  ItemType extends EmbeddedItem = EmbeddedItem,
>({
  label,
  sourceField,
  emptyText = EMPTY_FIELD,
  render,
  ...restProps
}: EmbeddedArrayFieldProps<RecordType, ItemType>) => {
  return (
    <FunctionField
      {...restProps}
      label={label}
      render={(record: RecordType) => {
        const values = get(record, sourceField) as ItemType[] | undefined;

        if (!values || !values.length) {
          return <span>{emptyText}</span>;
        }

        if (render) {
          return render(values, record);
        }

        return (
          <Stack direction="row" flexWrap="wrap" spacing={1}>
            {values.map((v) => (
              <span key={v?.id || v?.['@id']}>{v?.name ?? 'Без имени'}</span>
            ))}
          </Stack>
        );
      }}
    />
  );
};
